export const DOCS_BASE_URL = (process.env.REACT_APP_DOCS_URL || '/docs').replace(/\/$/, '');

export const DOCS_ARTICLES = {
  gettingStarted: '/getting-started',
  permissionModel: '/getting-started/permission-model',
  dashboard: '/dashboard',
  emails: '/communication/emails',
  library: '/communication/library',
  clients: '/communication/clients',
  appointments: '/work-management/appointments',
  todos: '/work-management/todos',
  syncStatus: '/work-management/sync-status',
  users: '/settings/users',
  permissions: '/settings/permissions',
  configurationSettings: '/settings/configuration-settings',
  customFields: '/settings/custom-fields',
  parameters: '/settings/parameters',
  fileStorage: '/settings/file-storage',
  emailAccounts: '/communication/email-accounts',
  emailSignatures: '/communication/email-signatures',
  searchFolders: '/settings/search-folders',
  emailRules: '/settings/email-rules',
  syncLogs: '/settings/sync-logs',
  systemHealth: '/settings/system-health',
  activityLogs: '/settings/activity-logs',
  databaseBrowser: '/tools/database-browser',
  importOrganizations: '/tools/import-organizations',
  profileAndPreferences: '/account/profile-and-preferences',
  crossModuleFeatures: '/reference/cross-module-features',
  permissionQuickReference: '/reference/permission-quick-reference',
} as const;

export type DocsArticleSlug = keyof typeof DOCS_ARTICLES;

/**
 * Manual home page (Welcome).
 */
export function docsHomeUrl(_locale?: string): string {
  return `${DOCS_BASE_URL}/`;
}

/**
 * Build a URL to a manual article.
 */
export function docsArticleUrl(slug: DocsArticleSlug, _locale?: string): string {
  const path = DOCS_ARTICLES[slug];
  return `${DOCS_BASE_URL}${path}`;
}
